import { render, staticRenderFns } from "./PrintReserve.vue?vue&type=template&id=13152883&scoped=true"
import script from "./PrintReserve.vue?vue&type=script&lang=js"
export * from "./PrintReserve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13152883",
  null
  
)

export default component.exports